import './TimeseriesSelectionArea.css';
export var timeseriesSelectionArea = '_15xgbwh0-2-0-1';